import React from 'react';
import { CalendarSkeleton } from '@jira/servicedesk__resources-calendar/src/CalendarSkeleton.tsx';
import { token } from '@atlaskit/tokens';
import Skeleton from '@atlaskit/skeleton';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import { cssMap } from '@atlaskit/css';

const styles = cssMap({
	filtersContainer: {
		marginTop: token('space.600'),
	},
	calendarContainer: {
		height: '100vh',
		paddingLeft: token('space.200'),
		marginTop: token('space.400'),
	},
});

export const SchedulesPageSkeleton = (): React.JSX.Element => (
	<>
		<Flex direction="row" justifyContent="space-between" alignItems="center" gap="space.100">
			<Skeleton height="64px" width="100%" />
			<Skeleton height="64px" width="100%" />
			<Skeleton height="64px" width="100%" />
		</Flex>
		<Flex justifyContent="end" xcss={styles.filtersContainer}>
			<Skeleton height="35px" width="300px" />
		</Flex>
		<Flex
			direction="row"
			justifyContent="center"
			alignItems="start"
			xcss={styles.calendarContainer}
		>
			<CalendarSkeleton rowCount={6} />
		</Flex>
	</>
);
